// Cuenta visitas y algunos clics de las páginas públicas (ver
// backend/src/lib/visitas.ts). No manda nada de la persona: de qué página es,
// si este navegador ya había venido antes, la campaña del enlace (?utm_source=
// o ?ref=) y el sitio desde donde llegó.
import { API_URL } from './api';

type Pagina = 'portada' | 'chatbularis' | 'aprende' | 'estado';
type Evento = 'visita' | 'clic_prueba' | 'registro_iniciado' | 'video_carrusel';

const MARCA = 'tb-ya-visito';
// Una sola visita por página y carga: React monta dos veces en desarrollo.
const contadas = new Set<string>();

export function registrarVisita(pagina: Pagina, evento: Evento = 'visita') {
  try {
    if (evento === 'visita') { if (contadas.has(pagina)) return; contadas.add(pagina); }
    let nuevo = false;
    try { nuevo = !localStorage.getItem(MARCA); if (nuevo) localStorage.setItem(MARCA, '1'); } catch { /* sin almacenamiento: cuenta igual */ }
    if (evento !== 'visita') nuevo = false;
    const q = new URLSearchParams(window.location.search);
    const cuerpo = JSON.stringify({
      pagina, evento, nuevo,
      campana: q.get('utm_source') || q.get('ref') || undefined,
      referente: document.referrer || undefined,
    });
    const url = `${API_URL}/publico/visita`;
    // sendBeacon sobrevive a un cambio de página (el clic en "Probar" abre el registro).
    if (!(navigator.sendBeacon && navigator.sendBeacon(url, new Blob([cuerpo], { type: 'text/plain' })))) {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: cuerpo, keepalive: true }).catch(() => {});
    }
  } catch { /* el contador nunca rompe la página */ }
}
